import { useCallback, useState } from 'react';
import ServiceContractPdf from './ServiceContractPdf/ServiceContractPdf';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';
import CheckoutBox from '../../../components/core/CheckoutBox/CheckoutBox';
import TermsConditionsAgreementInput from '../../../components/forms/inputs/TermsConditionsAgreement';
import ViaeroButton from 'components/core/ViaeroButton/ViaeroButton';
import MonthlyPaymentContract from './MonthlyPaymentContract/MonthlyPaymentContract';
import useServiceContractsStyles from './ServiceContracts.styles';

const ServiceContracts = () => {
    const styles = useServiceContractsStyles();

    const { cart, updateAgreements } = useCart();

    const [endOfDocumentReached, setEndOfDocumentReached] = useState<boolean>(false);
    const [termsAndAgreementsChecked, setTermsAndAgreementsChecked] = useState<boolean>(false);
    const [termsAndAgreementsShown, setTermsAndAgreementsShown] = useState<boolean>(true);
    const [monthlyPaymentContractShown, setMonthlyPaymentContractShown] = useState<boolean>(false);

    const handleTermsConditionsAgreement = useCallback(
        (value: boolean) => {
            const agreements = {
                ...cart.agreements,
                acceptedServiceContract: value
            };
            updateAgreements(agreements);
            setTermsAndAgreementsChecked(value);
        },
        [cart]
    );

    const handleClick = () => {
        setTermsAndAgreementsShown(false);
        setMonthlyPaymentContractShown(true);
        scrollTo(0, 0);
    };

    return (
        <CheckoutBox header={'Service Contracts'}>
            {termsAndAgreementsShown && (
                <div className={styles.root}>
                    <ServiceContractPdf setEndOfDocumentReached={setEndOfDocumentReached} />
                    <TermsConditionsAgreementInput
                        checked={termsAndAgreementsChecked}
                        onChange={handleTermsConditionsAgreement}
                        disabled={!endOfDocumentReached}
                    />
                    <ViaeroButton
                        click={handleClick}
                        text={'Agree and Continue'}
                        className={styles.agreeButton}
                        disabled={!termsAndAgreementsChecked}
                    />
                </div>
            )}

            {monthlyPaymentContractShown && <MonthlyPaymentContract />}
        </CheckoutBox>
    );
};

export default ServiceContracts;
